import { Button } from "@/shared/components/Button";
import { useEmailVerificationPendingViewModel } from "../../viewmodel/useEmailVerificationPendingViewModel";
import { useInlineLoading } from "@/shared/loading";
import styles from "./EmailVerificationPendingPage.module.css";

/**
 * EmailVerificationPendingForm Component
 * Pure presentational component - all logic in ViewModel
 */
export const EmailVerificationPendingForm = () => {
  const { email, isLoading, updateEmail, handleResend, goToLogin } =
    useEmailVerificationPendingViewModel();

  const BUTTON_ID = "resend-verification-button";
  const { isLoading: isInlineLoading } = useInlineLoading(BUTTON_ID);
  const buttonLoading = isLoading || isInlineLoading;

  return (
    <div className={styles.formContainer}>
      <h1 className={styles.title}>Verify your email</h1>
      <p className={styles.subtitle}>
        We&apos;ve sent a verification link to your registered email address.
      </p>
      <p className={styles.message}>
        Please verify your email to activate your account. Once verified, you can{" "}
        <Button onClick={goToLogin} className={styles.link}>
          log in here
        </Button>
        .
      </p>
      <p className={styles.helperText}>
        If you don&apos;t see the email in your inbox, please check your spam or junk folder.
      </p>
      <form className={styles.form} onSubmit={handleResend}>
        <div className={styles.inputGroup}>
          <label className={styles.label} htmlFor="email">
            Email
          </label>
          <input
            id="email"
            type="email"
            className={styles.input}
            value={email}
            onChange={(e) => updateEmail(e.target.value)}
            placeholder="Enter your email to resend link"
            disabled={true}
          />
        </div>
        <button
          id={BUTTON_ID}
          type="submit"
          className={styles.continueButton}
          disabled={buttonLoading}
        >
          {buttonLoading ? "Resending..." : "Resend verification email"}
        </button>
      </form>
    </div>
  );
};
